import type { GameKindAdapter } from "../shared/adapter";
import { compileSourceGame } from "./compiler";
import { evaluateSourceGame } from "./evaluator";
import { parseSourceGameSpec, type SourceGameSpec } from "./spec";

export const sourceGameAdapter: GameKindAdapter = {
  kind: "source-game",
  briefHints: ["any original browser game", "simulation", "strategy", "action", "role-playing", "open world", "game-specific mechanics"],
  promptSchemaLine: '{"version":1,"kind":"source-game","title":"original title","seed":integer,"blueprint":{...},"source":{"markup":"HTML fragment","styles":"CSS","script":"JavaScript using $CARCADE"}}',
  parseSpec: parseSourceGameSpec,
  compile: (spec) => compileSourceGame(spec as SourceGameSpec),
  evaluate: (spec) => evaluateSourceGame(spec as SourceGameSpec),
  repairCommandsFor: () => null,
};

export type { SourceGameSpec } from "./spec";
